import { Heading } from '@workday/canvas-kit-react/text';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { ElementType } from 'react';

export const ThemedHeading = ({ as = 'h2', ...props }: React.ComponentProps<typeof Heading> & { as?: ElementType }) => {
  return <Heading color={WcpStyles.color.text.default} as={as} {...props} />;
};
